module.exports = __webpack_public_path__ + "static/media/karl40.1d109f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/karlneval/karl40.jpg
// module id = 698
// module chunks = 0